import styled from "styled-components";

const FormSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  margin: 0 0 1rem 0;
`;

export default FormSection;
